import urlConfig from '../configs/url-config'
import fetchUtil from '../util/fetchUtil'
import authHeaderUtil from '../util/authHeaderUtil'
import ShareLevel from '@/constants/Day6ShareLevel'

const updateBodyDimensionsField = async (endPath, idSummary, data) => {
  const method = 'POST'
  const url = `${urlConfig.functionsBaseUrl}/day6AccountData/character-dimensions/${idSummary}/${endPath}`
  const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
  const headers = authHeader.headers
  const response = await fetchUtil.request({ method, url, headers, data })
  return response.ok
}

export default {
  updateSummaryModified: async (idSummary) => updateBodyDimensionsField('modified', idSummary),

  updateSummaryName: async (idSummary, name) => updateBodyDimensionsField('name', idSummary, { name }),

  updateSummaryNotes: async (idSummary, notes) => updateBodyDimensionsField('notes', idSummary, { notes }),

  // TODO Not fully tested
  updateShareLevel: async ({ idSummary, idDimensions, shareLevel }) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6AccountData/character-dimensions/${idSummary}/share`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const data = { idDimensions, shareLevel }
    const response = await fetchUtil.request({ method, url, headers, data })
    let buildResponse = {}
    if (response.ok) {
      let shareId
      if (shareLevel !== ShareLevel.PRIVATE) {
        ({ shareId } = await response.json())
      }
      buildResponse = { shareId, success: true }
    } else {
      buildResponse = { success: false }
    }
    return buildResponse
  },

  deleteSummary: async (idSummary) => {
    const method = 'DELETE'
    const url = `${urlConfig.functionsBaseUrl}/day6AccountData/character-dimensions/${idSummary}`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers })
    return response.ok
  },

  setActivePoseSequence: async ({ idAnimationGroup, idSequence }) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6PoseAnimation/character-animations/${idAnimationGroup}/${idSequence}/active`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers })
    // TODO Handle 304 if ever necessary
    return response.ok
  },

  updatePoseSequenceName: async ({ idAnimationGroup, idSequence, name }) => {
    const method = 'POST'
    const url = `${urlConfig.functionsBaseUrl}/day6PoseAnimation/character-animations/${idAnimationGroup}/${idSequence}/name`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const data = { name }
    const response = await fetchUtil.request({ method, url, headers, data })
    // TODO Handle 304 if ever necessary
    return response.ok
  },

  deletePoseSequence: async ({ idAnimationGroup, idSequence }) => {
    const method = 'DELETE'
    const url = `${urlConfig.functionsBaseUrl}/day6PoseAnimation/character-animations/${idAnimationGroup}/${idSequence}`
    const authHeader = await authHeaderUtil.getIdTokenHeaderAsync()
    const headers = authHeader.headers
    const response = await fetchUtil.request({ method, url, headers })
    return response.ok
  }
}
